export default "__VITE_ASSET__DspQf8iq__"